import { render } from "./Contact.vue?vue&type=template&id=d46005a0"
import script from "./Contact.vue?vue&type=script&scoped=true&lang=js"
export * from "./Contact.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__